
export enum ApiMethod {
    Get,
    Post,
    Put,
    Patch,
    Delete
}